import {Component, ViewEncapsulation} from "@angular/core";
import {routeAnimation} from "../shared/animations/route.animation";

@Component({
  templateUrl: './about-us.component.html',
  styleUrls: [ './about-us.component.scss' ],
  selector: 'aboutUsComponent',
  encapsulation: ViewEncapsulation.None,
  animations: [ routeAnimation ],
  host: {
    '[@routeAnimation]': 'true',
    '[style.display]': "'block'",
    '[style.position]': "'absolute'",
    '[style.left]' : "'0'",
    '[style.right]' : "'0'"
  },
})

export class AboutUsComponent {}



// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.ts